import {IProductTourStep} from '@toolify/client/src/modules/productTour/types/IProductTourStep'
import {ProductTourAnchorType} from '@toolify/client/src/modules/productTour/enum/ProductTourAnchorType'

// Steps whose anchor is missing or hidden (zen mode, mobile) are skipped by the store;
// the editor renders the title/editor anchors only while the document is editable, so
// a read-only document (read mode, missing permissions) skips the editing steps and
// keeps the ones that also make sense for a reader (status chip, comments).
export const documentProductTourSteps: IProductTourStep[] = [
  {
    name: 'canvas',
    anchor: ProductTourAnchorType.DocumentTitle,
    titleTranslationKey: 'productTour.document.canvas.title',
    descriptionTranslationKey: 'productTour.document.canvas.description',
    placement: 'bottom',
  },
  {
    name: 'slashCommands',
    // The editor surface covers most of the viewport, so the bubble centers over it
    anchor: ProductTourAnchorType.DocumentEditor,
    titleTranslationKey: 'productTour.document.slashCommands.title',
    descriptionTranslationKey: 'productTour.document.slashCommands.description',
    placement: 'top',
  },
  {
    name: 'mentions',
    anchor: ProductTourAnchorType.DocumentEditor,
    titleTranslationKey: 'productTour.document.mentions.title',
    descriptionTranslationKey: 'productTour.document.mentions.description',
    placement: 'top',
  },
  {
    name: 'toolbar',
    anchor: ProductTourAnchorType.DocumentStatusChip,
    titleTranslationKey: 'productTour.document.toolbar.title',
    descriptionTranslationKey: 'productTour.document.toolbar.description',
    placement: 'bottom',
  },
  {
    name: 'comments',
    anchor: ProductTourAnchorType.DocumentCommentsToggle,
    titleTranslationKey: 'productTour.document.comments.title',
    descriptionTranslationKey: 'productTour.document.comments.description',
    placement: 'left',
  },
]
